import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconClearFormat = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="13.395"
    height="13.422"
    viewBox="0 0 13.395 13.422"
    {...props}
  >
    <g transform="translate(-15.043 -28.44)">
      <path
        d="M5746.165-8336h-2.608l2.956-8.41,1.693,1.693-.136.444c-.129.421-.29.946-.468,1.521h2.568l3.327,3.327a1.231,1.231,0,0,0,.721.355l.376,1.068h-2.61l-.828-2.72h-4.165l-.828,2.72Zm6.322-5.972-3.3-3.3c-.045-.158-.083-.306-.11-.428-.01.041-.022.086-.035.134l-.032.117-1.58-1.58.156-.443h2.96l1.94,5.5Z"
        transform="translate(-5728.513 8377)"
      />
      <g transform="translate(16.676 28.44) rotate(45)" strokeWidth="1">
        <rect width="15.5" height="1.5" rx="0.75" stroke="none" />
        <rect x="0.5" y="0.5" width="14.5" height="0.5" rx="0.25" fill="none" />
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconClearFormat)
